// @flow strict
// This component's logic is specific to adjust's implementation
// https://docs.adjust.com/en/impression-tracking/
// name is a variable, because this pixel can be used to track the impression of anything we set
import React from 'react'
import styles from './AdjustImpressionPixel.module.scss'
import objectToQueryString, {
  type queryParamsObject,
} from '@mondough/public-web-components/src/utils/objectToQueryString'

const AdjustImpressionPixel = ({
  queryParams,
}: {
  queryParams: queryParamsObject,
}) => {
  const additionalQueryParams = objectToQueryString(queryParams, {
    encoded: true,
  })
  const src = `${
    process.env.GATSBY_ADJUST_INSTALL_TRACKING_URL
  }${additionalQueryParams}`
  return <img className={styles.pixel} src={src} alt="" />
}

export default AdjustImpressionPixel
